import React from "react";
import i18next from "src/i18n/config";
import UserSettingsService from "src/services/userSettingsService";
import { makeStyles } from "tss-react/mui";

import { useHasEnrolledDevice } from "@dashboard/enrollment/utils/useHasEnrolledDevice";
import { PageContainer } from "@dashboard/shared/components/PageContainer";
import { useCurrentSubscriptionExpired, useCurrentWorkspace } from "@dashboard/workspaces/api/helpers";
import { Box, Theme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { withMetaDescription } from "@navigation/utils/withMetaDescription";
import { ExpiredWrapper } from "@shared/ExpiredWrapper";

import { EnrollFirstDeviceSection } from "./components/EnrollFirstDeviceSection";
import { Filter } from "./components/Filter";
import { StatisticSection } from "./components/StatisticSection/StatisticSection";
import { WorkspaceClaimSection } from "./components/WorkspaceClaimSection";

const useStyles = makeStyles()((theme: Theme) => ({
    contentBox: { marginTop: theme.spacing(3), width: "100%" },
    overviewContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-start",
        [theme.breakpoints.down("sm")]: {
            marginRight: theme.spacing(2),
        },
    },
}));

const OverviewPage = () => {
    const [filter, setFilter] = React.useState<number[]>(UserSettingsService.getOverviewPageGroupFilter());
    const { classes } = useStyles();

    const isExpired = useCurrentSubscriptionExpired();
    const { data: workspace, isLoading: isWorkspaceLoading } = useCurrentWorkspace();
    const hasEnrolledDevice = useHasEnrolledDevice();

    if (isWorkspaceLoading) {
        return null;
    }

    if (!workspace) {
        return (
            <PageContainer>
                <WorkspaceClaimSection />
            </PageContainer>
        );
    }

    if (hasEnrolledDevice === false) {
        return (
            <PageContainer fitViewport>
                <ExpiredWrapper>
                    <EnrollFirstDeviceSection />
                </ExpiredWrapper>
            </PageContainer>
        );
    }

    return (
        <PageContainer>
            <ExpiredWrapper>
                <Box className={classes.overviewContainer}>
                    {!isExpired ? <Filter filter={filter} setFilter={setFilter} /> : null}
                    <Grid container spacing={1} className={classes.contentBox}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <StatisticSection {...{ filter }} />
                        </Grid>
                    </Grid>
                </Box>
            </ExpiredWrapper>
        </PageContainer>
    );
};

export default withMetaDescription(OverviewPage, {
    title: i18next.t("pages:overviewPage.metaTitle"),
});
